const RetrieveImage = (ref, sizes) => {
  if (ref?.includes("proxyImagenes")) {
    const urlToUse = ref;
    if (urlToUse.includes("width=")) {
      // replace width parameter with the provided sizes
      return urlToUse.replace(/width=\d+/, `width=${sizes}`);
    } else {
      if (urlToUse.includes("?")) {
        return urlToUse + "&width=" + sizes;
      } else {
        return urlToUse + "?width=" + sizes;
      }
    }
  }

  var baseURI =
    "https://firebasestorage.googleapis.com/v0/b/micatalogovirtual-7bfd1.appspot.com/o/" +
    encodeURIComponent(ref.replace(/^\//, "")) +
    "?alt=media";
  return baseURI;
};

export default RetrieveImage;
